<template>
  <div class="w-full h-full flex flex-col items-center bg-backgroundColor">
    <BannerSection :banner="banner" :loading="loading" />
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%] pt-16 pb-2">
      <CardNews />
    </div>
  </div>
</template>

<script>
import BannerSection from "@/components/BannerSection.vue";
import CardNews from "@/components/News/CardNews.vue";
import { db } from "@/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

export default {
  name: "NewsEventPage",
  components: { CardNews, BannerSection },
  data() {
    return {
      banner: {},
      loading: true
    };
  },
  mounted() {
    this.fetchBanner();
  },
  methods: {
    async fetchBanner() {
      try {
        const snapshot = await getDocs(collection(db, "newsBanner"));
        const firstDoc = snapshot.docs[0];
        if (firstDoc) {
          this.banner = { id: firstDoc.id, ...firstDoc.data() };
        }
      } catch (e) {
        console.error("Error fetching banner:", e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
